//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { mapMutations } from 'vuex'
  export default {
    name:'TASH',
    data() {
      return {
        defaultJson:{
          "Clinically Unstable Pelvic Fracture": "临床不稳定的骨盆骨折",
          "Risk": "风险",
          "TASH": "TASH",
          "Hemoglobin": "血红蛋白",
          "SBP": "SBP",
          "Free Intra-abdominal Fluid": "游离腹腔积液",
          "Base Excess": "碱剩余",
          "(of massive transfusion)": "（大量输血概率）",
          "Open and\/or Dislocated Femur Fracture": "开放性和 \/ 或移位的股骨骨折",
          "Systolic Blood Pressure": "收缩压",
          "Heart Rate > 120 bpm": "心率 > 120 bpm"
        },
        form:{
          sbpSwitch:'4',
          gender:'1',
          hb:'',
          bee:'',
          freeAbdoFluid:'0',
          heartRate:'0',
          femur:'0',
          pelvic:'0',
        },
        contentDescription:'',
        hasScore:false,
        disabled:false,
        dataList1:[
          {value:"4",name:'<100'},
          {value:"1",name:'100-119'},
          {value:"0",name:'≥120'},
        ],
        dataList2:[
          {value:"0",name:'女'},
          {value:"1",name:'男'},
        ],
        risk:'--',
        descTxt:'（大量输血概率）',
      }
    },
    created () {
      this.hideLoad()
    },
    methods: {
      ...mapMutations(['hideLoad']),
    },
    computed: {
      /** 计算公式结果 */
      score() {
        let self = this
        let form = JSON.parse(JSON.stringify(self.form))
        let flag = true
        for (const key in form) {
          if (form.hasOwnProperty(key)) {
            if (!form[key]) {
              flag = false
            } else { 
              if (form[key]=='---') {
                flag = false
              } else {  
                form[key] = Number(form[key])
              }
            }
          }
        }
        if (!flag) {
          self.hasScore = false
          self.risk = '--'
          return '--'
        } else { 
		      // gender + sbpSwitch + (freeAbdoFluid ? 3 : 0) + (pelvic ? 6 : 0)	+ (femur ? 3 : 0)	+ (heartRate ? 2 : 0)	+ (hb < 7 ? 8 : (hb < 9 ? 6 : (hb < 10 ? 4 : (hb < 11 ? 3 : (hb < 12 ? 2 : 0)))))	+ (bee < -10 ? 4 : (bee < -6 ? 3 : (bee < -2 ? 1 : 0)));
          let result = form.gender + form.sbpSwitch + (form.freeAbdoFluid ? 3 : 0) + (form.pelvic ? 6 : 0)	+ (form.femur ? 3 : 0)	+ (form.heartRate ? 2 : 0)	+ (form.hb < 7 ? 8 : (form.hb < 9 ? 6 : (form.hb < 10 ? 4 : (form.hb < 11 ? 3 : (form.hb < 12 ? 2 : 0)))))	+ (form.bee < -10 ? 4 : (form.bee < -6 ? 3 : (form.bee < -2 ? 1 : 0)));

          // 100 / (1 + e^(5.4 - (0.3 * score)))
          let risk  = 100 / (1 + Math.pow(Math.E, (5.4 - (0.3 * result))))

          self.risk = String(risk.toFixed(1))
          self.hasScore = true
          return String(result.toFixed(0))
        }
      }
    },
    
    
  }



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/TASH.vue